import {
    GET_RECEIVABLES_S3_SIGNED_URL,
    UPDATE_INVOICE,
    ADD_COMMENT_FOR_INVOICE,
    FETCH_COMMENT_HISTORY,
    FETCH_EVENT_HISTORY,
    SUBMIT_INVOICE,
    SETTLE_RECEIVABLES_INVOICE,
    RAISE_SETTLEMENT_DISPUTE,
    SEARCH_HUBS,
    SEND_PAYOUT_FOR_REVIEW,
    BULK_SEND_PAYOUT_FOR_REVIEW,
    GET_ACTIVE_ADHOC_CHARGES,
    GET_CONSIGNMENT_DETAILS,
    GET_S3_SIGNED_URL_ADHOC,
    ADD_ADHOC_CHARGES,
    DOWNLOAD_PAYOUT_EXCEL,
    FETCH_PAYOUT_EVENTS,
    DOWNLOAD_RECEIVABLES_INVOICE,
    DOWNLOAD_SAMPLE_ADHOC_CHARGES_EXCEL,
    UPLOAD_BULK_ADHOC_CHARGES,
    PROCESS_SINGLE_ADHOC_CHARGE,
    DOWNLOAD_UPLOAD_REQUESTS_FILE,
    FETCH_TRIP_REFERENCES_FOR_VEHICLE,
} from 'src/api/routes';
import { POST, GET } from 'src/network/apiHandler';
import config from 'src/globals';
import apiProvider from 'src/network/api-provider';

const { API_BASE_URL, FINANCE_SERVICE_URL } = config;

export const searchHubs = async (queryStr: string) => {
    return GET(`${API_BASE_URL}${SEARCH_HUBS}`, { queryStr });
};

export const getS3Url = async (body) => {
    return GET(`${FINANCE_SERVICE_URL}${GET_RECEIVABLES_S3_SIGNED_URL}`, body);
};

export const fetchCommentHistory = async (params) => {
    return POST(`${FINANCE_SERVICE_URL}${FETCH_COMMENT_HISTORY}`, params);
};
export const fetchEventHistory = async (params) => {
    return POST(`${FINANCE_SERVICE_URL}${FETCH_EVENT_HISTORY}`, params);
};

export const addCommentForInvoice = async (params) => {
    return POST(`${FINANCE_SERVICE_URL}${ADD_COMMENT_FOR_INVOICE}`, params);
};

export const updateInvoice = async (body) => {
    return POST(`${API_BASE_URL}${UPDATE_INVOICE}`, body);
};

export const settleInvoice = async (body) => {
    return POST(`${FINANCE_SERVICE_URL}${SETTLE_RECEIVABLES_INVOICE}`, body);
};

export const raiseSettlementDispute = async (body) => {
    return POST(`${FINANCE_SERVICE_URL}${RAISE_SETTLEMENT_DISPUTE}`, body);
};

export const submitInvoice = async (body) => {
    return POST(`${FINANCE_SERVICE_URL}${SUBMIT_INVOICE}`, body);
};

const withViewType = <T extends Record<string, unknown>>(
    body: T,
    viewType?: string,
): T & { view_type?: string } => {
    return viewType ? { ...body, view_type: viewType } : body;
};

export const sendPayoutForReview = async (payoutId: string, viewType?: string) => {
    return POST(
        `${FINANCE_SERVICE_URL}${SEND_PAYOUT_FOR_REVIEW}`,
        withViewType({ payout_id: payoutId }, viewType),
    );
};

export const bulkSendPayoutForReview = async (payoutIds: string[], viewType?: string) => {
    return POST(
        `${FINANCE_SERVICE_URL}${BULK_SEND_PAYOUT_FOR_REVIEW}`,
        withViewType({ payout_ids: payoutIds }, viewType),
    );
};

export const getActiveAdhocCharges = async (entityType: string) => {
    return GET(`${FINANCE_SERVICE_URL}${GET_ACTIVE_ADHOC_CHARGES}`, { entityType });
};

export const getConsignmentDetails = async (referenceNumber: string) => {
    const params = {
        referenceNumber,
        statusList: '["delivered","pickup_completed"]',
        type: 'flm',
    };
    return GET(`${API_BASE_URL}${GET_CONSIGNMENT_DETAILS}`, params);
};

export const getS3SignedUrlAdhoc = async (chargeId: string) => {
    return GET(`${FINANCE_SERVICE_URL}${GET_S3_SIGNED_URL_ADHOC}`, { charge_id: chargeId });
};

export const addAdhocCharges = async (payload: any, viewType?: string) => {
    return POST(`${FINANCE_SERVICE_URL}${ADD_ADHOC_CHARGES}`, withViewType(payload, viewType));
};
export const downloadPayoutExcel = async (params, viewType?: string) => {
    return POST(`${FINANCE_SERVICE_URL}${DOWNLOAD_PAYOUT_EXCEL}`, withViewType(params, viewType));
};

export const getPayoutEvents = async (body: { id: string }, viewType?: string) => {
    return POST(`${FINANCE_SERVICE_URL}${FETCH_PAYOUT_EVENTS}`, withViewType(body, viewType));
};

export const downloadReceivablesInvoice = async (params) => {
    return POST(`${FINANCE_SERVICE_URL}${DOWNLOAD_RECEIVABLES_INVOICE}`, params);
};

export const putImageS3 = async (url, file, contentType) => {
    try {
        await apiProvider.put(url, file, {
            headers: {
                'Content-Type': contentType,
            },
        });
        return {
            isSuccess: true,
        };
    } catch (err) {
        return {
            isSuccess: false,
            errorMessage: err.message,
        };
    }
};

export const downloadSampleAdhocChargesExcel = async () => {
    return GET(`${FINANCE_SERVICE_URL}${DOWNLOAD_SAMPLE_ADHOC_CHARGES_EXCEL}`, {}, 'blob');
};

export const uploadBulkAdhocCharges = async (payload: {
    uploadData: any[];
    validateOnly?: boolean;
    bypassValidation?: boolean;
}) => {
    return POST(`${FINANCE_SERVICE_URL}${UPLOAD_BULK_ADHOC_CHARGES}`, payload);
};

export const processSingleAdhocCharge = async (payload: {
    uploadData: any[];
    dataHeaders: string[];
    bulkUploadData: { batchNumber: number; totalBatches: number };
}, viewType?: string) => {
    return POST(`${FINANCE_SERVICE_URL}${PROCESS_SINGLE_ADHOC_CHARGE}`, withViewType(payload, viewType));
};

export const downloadUploadRequestsFile = async (params: { actionType: string }) => {
    return GET(`${FINANCE_SERVICE_URL}${DOWNLOAD_UPLOAD_REQUESTS_FILE}`, params);
};

export const fetchTripReferencesForVehicle = async (params: {
    vehicleNumber: string;
    fromDate: string;
    toDate: string;
    viewTypeKey?: string;
    viewTypeValue?: string;
}) => {
    return GET(`${API_BASE_URL}${FETCH_TRIP_REFERENCES_FOR_VEHICLE}`, params);
};

export const fetchPayoutDetails = async (payoutId: string, viewType?: string) => {
    const endpoint = `/vendorPayout/vendor/payouts/${payoutId}/details`;
    return GET(`${FINANCE_SERVICE_URL}${endpoint}`, withViewType({ timestamp: Date.now() }, viewType));
};

export const fetchPayoutCharges = async (payoutId: string, groupKey: string, viewType?: string) => {
    const endpoint = `/vendorPayout/vendor/payouts/${payoutId}/charges`;
    return GET(
        `${FINANCE_SERVICE_URL}${endpoint}`,
        withViewType({ group_key: groupKey, timestamp: Date.now() }, viewType),
    );
};
